export default __webpack_public_path__ + "static/media/cow.f32f5218.svg";